import apiClient from "./axios"

export const getMoneyReceiptComplimentaryItems = async (params = {}) => {
  const { data } = await apiClient.get("/money-receipt-complimentary-items", { params })
  return data
}

export const getMoneyReceiptComplimentaryItem = async id => {
  const { data } = await apiClient.get(`/money-receipt-complimentary-items/${id}`)
  return data
}

export const createMoneyReceiptComplimentaryItem = async (payload, options = {}) => {
  const { data } = await apiClient.post("/money-receipt-complimentary-items", payload, {
    skipToast: true,
    ...options,
  })
  return data
}

export const updateMoneyReceiptComplimentaryItem = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(
    `/money-receipt-complimentary-items/${id}`,
    payload
  )
  return data
}

export const deleteMoneyReceiptComplimentaryItem = async id => {
  const { data } = await apiClient.delete(`/money-receipt-complimentary-items/${id}`)
  return data
}

export const getAllMoneyReceiptComplimentaryItems = async (params = {}) => {
  const { data } = await apiClient.get("/money-receipt-complimentary-items", {
    params: { ...params, all: true },
  })
  return data
}

export const searchMoneyReceiptComplimentaryItems = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/money-receipt-complimentary-items", {
    params: { ...params, search: searchTerm },
  })
  return data
}
